import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

export const getIANAtimeZone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone;

export const convertUTCStringToLocalTime = (
  UTCdate,
  timeZone = getIANAtimeZone(),
  format = "YYYY-MM-DDTHH:mm",
) => {
  return dayjs.utc(UTCdate).local().tz(timeZone).format(format);
};

export const getLocalISOStringDate = (date, format = "YYYY-MM-DDTHH:mm") => {
  return dayjs(date).format(format);
};

export const convertLocalTimeToUTCString = (
  LocalTime,
  timeZone = getIANAtimeZone(),
) => {
  return dayjs.tz(LocalTime, timeZone).toISOString();
};

export const currentLocalDateTime = getLocalISOStringDate(new Date());

export const isFutureDateTime = (DateTime) =>
  DateTime ? dayjs().isBefore(dayjs(DateTime)) : false;

export const monthDayYearFormat = (DateTime) =>
  DateTime ? dayjs(DateTime).format("M/DD/YY") : null;
